import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import PropTypes from "prop-types";
import useLogger from "../../util/Logger";
import "./PropertyClosedWorkOrder.css";

function PropertyClosedWorkOrder({ closedWorkOrder }) {
  const logger = useLogger();
  const navigate = useNavigate();

  const { propertyId } = useParams();

  const clickWorkOrder = async () => {
    logger.debug(
      "PropertyClosedWorkOrder.clickWorkOrder",
      `propertyId=${propertyId} closedWorkOrderId=${closedWorkOrder?.id}`
    );
    navigate(`/property/${propertyId}/workorder/${closedWorkOrder.id}`);
  };

  const view = (
    <tr className="property-search-result" onClick={clickWorkOrder}>
      <td>{closedWorkOrder.reference}</td>
      <td>
        {closedWorkOrder.createdOn
          ? moment(closedWorkOrder.createdOn).format("DD/MM/YYYY h:mm a")
          : ""}
      </td>
      <td>
        {closedWorkOrder.closedOn
          ? moment(closedWorkOrder.closedOn).format("DD/MM/YYYY h:mm a")
          : ""}
      </td>
      <td>{closedWorkOrder.type}</td>
      <td>{closedWorkOrder.category}</td>
      <td>{closedWorkOrder.subCategory}</td>
      <td>{closedWorkOrder.status}</td>
    </tr>
  );

  return view;
}

PropertyClosedWorkOrder.propTypes = {
  closedWorkOrder: PropTypes.shape({
    id: PropTypes.string,
    reference: PropTypes.string,
    category: PropTypes.string,
    subCategory: PropTypes.string,
    createdOn: PropTypes.number,
    status: PropTypes.string,
    type: PropTypes.string,
    closedOn: PropTypes.number,
  }).isRequired,
};

export default PropertyClosedWorkOrder;
